import { supabase } from './supabase';

export const logNegotiationAction = async (
    negotiationId: number,
    userId: string | undefined,
    action: string,
    details?: any
) => {
    if (!userId) {
        console.warn('Logger: No user ID provided for negotiation log:', action);
        return;
    }

    try {
        const { error } = await supabase
            .from('negociacao_logs')
            .insert({
                negociacao_id: negotiationId,
                user_id: userId,
                acao: action,
                detalhes: details ? JSON.stringify(details) : null
            });

        if (error) {
            console.error('Logger: Failed to save negotiation log', error);
        }
    } catch (err) {
        console.error('Logger: Unexpected error', err);
    }
};
